import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as ProyectoService from 'services/proyecto.service'

const ProyectoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaProyectos, setListaProyectos] = React.useState([])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value

      if (nuevoValor) {
        const matchProyecto = listaProyectos.find(x => x._id === nuevoValor)
        setFieldValue('infoProyecto', matchProyecto.descripcion)
      } else {
        setFieldValue('infoProyecto', '')
      }
    },
    [handleChange, setFieldValue, listaProyectos]
  )

  React.useEffect(() => {
    ProyectoService.obtenerAsSelect()
      .then(({ data }) => {
        setListaProyectos(data)
      })
      .catch(({ data: { error } }) => {
        __zariContext.toast('error', error)
        setListaProyectos([])
      })
  }, [__zariContext])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('movimientoPresupuesto-select2-codigoPresupuesto', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='PROYECTO' htmlFor='movimientoPresupuesto-select-proyecto' md={12} />
        <Col md={12}>
          <Field name='_idProyecto'>
            {({ field }) => (
              <Form.Select
                {...field}
                id='movimientoPresupuesto-select-proyecto'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting}
                onChange={onChange}
                onKeyDown={onKeyDown}
              >
                <option value=''>Seleccionar</option>
                {listaProyectos.map((x, k) => (
                  <option key={k} value={x._id}>
                    {x.descripcion}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ProyectoFormGroup)
